import { createAction, props } from '@ngrx/store';
import {
  IngredientCost,
  IngredientWithProductsRecipesAttributes,
  UpdateIngredientCost,
} from '../../models/ingredient';

export enum IngredientsCostsActionsTypes {
  LoadIngredientsCosts = 'Load Ingredients Costs',
  LoadIngredientsCostsSuccess = 'Load Ingredients Costs Success',
  LoadIngredientsCostsError = 'Load Ingredients Costs Error',
  UpdateIngredientCost = 'Update Ingredient Cost',
  UpdateIngredientCostSuccess = 'Update Ingredient Cost Success',
  UpdateIngredientCostError = 'Update Ingredient Cost Error',
  ClearIngredientsCosts = 'Clear Ingredients Costs',
}

export const loadIngredientsCosts = createAction(
  IngredientsCostsActionsTypes.LoadIngredientsCosts,
);

export const loadIngredientsCostsSuccess = createAction(
  IngredientsCostsActionsTypes.LoadIngredientsCostsSuccess,
  props<{ ingredients: IngredientWithProductsRecipesAttributes[] }>()
);

export const loadIngredientsCostsError = createAction(
  IngredientsCostsActionsTypes.LoadIngredientsCostsError,
  props<{ errorMessage: string }>(),
);

export const updateIngredientCost = createAction(
  IngredientsCostsActionsTypes.UpdateIngredientCost,
  props<{ ingredientCost: UpdateIngredientCost }>()
);

export const updateIngredientCostSuccess = createAction(
  IngredientsCostsActionsTypes.UpdateIngredientCostSuccess,
  props<{ ingredientCost: IngredientCost }>()
);

export const updateIngredientCostError = createAction(
  IngredientsCostsActionsTypes.UpdateIngredientCostError,
  props<{ errorMessage: string }>(),
);

export const clearIngredientsCosts = createAction(
  IngredientsCostsActionsTypes.ClearIngredientsCosts,
);

